module.exports = __webpack_public_path__ + "img/20201103_fintech_and_the_new_normal.cf4f1d55.jpg";